<template>
    <div class="revision">
        <p v-if="revision.description">{{ revision.description }}</p>

        <small>Toegevoegd door {{ revision.author.name }} tijdens de {{ revision.inspection_type | formatType }}.</small>

        <ul v-if="revision.images.length > 0">
            <li v-for="(image, index) in getStructuredImages" :key="image.id">
                <img :src="image.thumb" :alt="image.caption" @click="openLightbox( 'lightbox-' + revision.id, index )">
            </li>
        </ul>

        <LightBox :images="getStructuredImages" ref="lightbox" :show-caption="true" :show-light-box="false"/>
    </div>
</template>

<script>
	import LightBox from 'vue-image-lightbox'
	import moment from 'moment-timezone'

	require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

	export default {
		props: ['revision'],

		components: { LightBox },

		methods: {
			openLightbox (lightbox, index) {
				this.$refs.lightbox.showImage(index)
			},
		},

		computed: {
			getStructuredImages ( ) {
				return this.revision.images.map((image) => {
					return {
						id: image.id,
						thumb: image.paths['hd-thumb'],
						src: image.paths.hd,
						caption: image.name,
					}
				})
			},
        },

		filters: {
			formatDate (value) {
				return moment(value).locale('nl').format('LL')
			},

			formatType (value) {
				if (value === 1) {
					return 'vooropname'
				}
				if (value === 2) {
					return 'tussenopname'
				}
				if (value === 3) {
					return 'extra opname'
				}
				if (value === 4) {
					return 'eindopname'
				}
			},
        },
	}
</script>

<style lang="scss" scoped>
    .revision {
        border: 1px solid #e6e6e6;
        margin-bottom: 10px;
        padding: 15px;

        p {
            margin-bottom: 0;
        }

        small {
            display: block;
        }

        ul {
            list-style: none;
            margin: 10px 0 0 0;
            padding: 0;

            li {
                display: inline-block;
                margin-right: 10px;

                img {
                    width: 96px;
                    height: 54px;
                    object-fit: contain;
                    cursor: pointer;
                }
            }
        }
    }
</style>